import { render, staticRenderFns } from "./admin_simple_claim_mgr.vue?vue&type=template&id=09f979b0&"
import script from "./admin_simple_claim_mgr.vue?vue&type=script&lang=js&"
export * from "./admin_simple_claim_mgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports